export default __webpack_public_path__ + "static/media/gallery1.f87467c6.jpg";